import(/* webpackMode: "eager" */ "/app/apps/youlli_client/src/app/[lang]/loading.tsx");
